/* eslint-disable no-unneeded-ternary */
import { Home, Circle, User, Tag, ShoppingCart, Search, LogOut, File, Upload, Briefcase, PlayCircle, HelpCircle, Package } from 'react-feather'
import icons from '../../assets/images/icons/icons'
import { store} from '../../redux/store'
import { hasParceria } from '../../utility/Utils'

const initialUser = () => {
  const item = window.localStorage.getItem('userData')
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : null
}
const botao = initialUser() !== null && initialUser().user.status  === 'teste' && !hasParceria() ? {
  id:"contrate",
  title: <h1 className='menuItens'>Contrate agora</h1>,
  icon: icons[2].icon,
  externalLink: true,
  newTab: true,
  navLink: 'https://api.whatsapp.com/send?phone=5596988084271&text=Ol%C3%A1%2C%20quero%20conhecer%20mais%20sobre%20os%20planos%20do%20Tributei!'
} : {
  id: "d-none"
}
export default [
  {
    id: 'home',
    title: <h1 className='menuItens'>Pagina Inicial</h1>,
    icon: <Home className='menuIcon' size={20} />,
    navLink: '/home'
  },
  botao,
  {
    id: 'user',
    title: <h1 className='menuItens'>Perfil</h1>,
    icon: <User className='menuIcon' size={20} />,
    navLink: "/perfil"
  },
  {
    id: 'empresas',
    title: <h1 className='menuItens'>Empresas</h1>,
    icon: <Briefcase className='menuIcon' size={20} />,
    navLink: "/empresas"
  },
  {
    id: 'XML',
    title: <h1 className='menuItens'>Documentos fiscais</h1>,
    icon: <File className='menuIcon' size={20} />,
    navLink: "/documentos-fiscais",
    disabled: initialUser() !== null && initialUser().user.acesso_captura === true ? false : true
  },
  {
    id: 'Calculo',
    title: <h1 className='menuItens'>Calculadora</h1>,
    icon: icons[0].icon,
    children: [
      {
        id: 'ICMS-ST',
        title: 'ICMS-ST',
        icon: <Circle size={12} />,
        navLink: '/calculadora/icmsst',
        disabled: initialUser() !== null && initialUser().user.acesso_st === true ? false : true
      },
      {
        id: 'DIFAL',
        title: 'DIFAL',
        icon: <Circle size={12} />,
        navLink: '/calculadora/difal',
        disabled: initialUser() !== null && initialUser().user.acesso_st === true ? false : true
      }
    ]
  },
  {
    id: 'produtos',
    title: <h1 className='menuItens'>Produtos</h1>,
    icon: <Package className='menuIcon' size={20} />,
    navLink: '/produtos'
    // disabled: initialUser() !== null && initialUser().user.acesso_guia === true ? false : true
  },
  {
    id: 'guias',
    title: <h1 className='menuItens'>Guias de pagamentos</h1>,
    icon: <Tag className='menuIcon' size={20} />,
    navLink: '/guias',
    disabled: initialUser() !== null && initialUser().user.acesso_guia === true ? false : true
  },
  {
    id: "Simulador",
    title: <h1 className='menuItens'>Simulador</h1>,
    icon: <ShoppingCart className='menuIcon' size={20} />,
    navLink: "/simulador",
    disabled: initialUser() !== null && initialUser().user.acesso_simulador === true ? false : true
  },
  {
    id: 'Consultas',
    title: <h1 className='menuItens'>Consultas</h1>,
    icon: <Search className='menuIcon' size={20} />,
    navLink: "/consultas",
    disabled: initialUser() !== null && initialUser().user.acesso_consulta === true ? false : true
  },
  {
    id: 'tutoriais',
    title: <h1 className='menuItens'>Tutoriais</h1>,
    icon: <PlayCircle className='menuIcon' size={20} />,
    navLink: "/tutoriais"
  },
  {
    id: 'Duvidas',
    title: <h1 className='menuItens'>FAQ</h1>,
    icon: <HelpCircle className='menuIcon' size={20} />,
    newTab: true,
    externalLink: true,
    navLink: "https://tributei.tawk.help/"
  }
]
